<template>
    <div class="vue-circular-progress embedded">
        <div class="circle">
            <svg :width="circleSize" :height="circleSize" class="circle__svg">
                <circle
                        :cx="centralP"
                        :cy="centralP"
                        :r="radius"
                        :style="{ 'stroke-width': strokeWidth, stroke: strokeColor }"
                        class="circle__progress circle__progress--path"
                ></circle>
                <circle
                        :cx="centralP"
                        :cy="centralP"
                        :r="radius"
                        :style="fileStyl"
                        class="circle__progress circle__progress--fill"
                ></circle>
                <circle
                        v-for="(entry, key) in staticProgressReversed"
                        :key="key"
                        :cx="centralP"
                        :cy="centralP"
                        :r="radius"
                        :style="getStaticStyle(entry, key)"
                        class="circle__progress circle__progress--fill"
                ></circle>
            </svg>

            <div class="percent">
                <slot>
                    <span class="percent__int">{{ convertNumberReadable(int,10) }}</span>
                    <span class="dot">,</span>
                    <span class="percent__dec">{{ dec }}</span>
                    <span class="percent_sign">%</span>
                </slot>
            </div>
        </div>

        <!-- Sonderspenden -->
        <!-- <ul class="static-progress-list" v-if="staticProgress">
            <li>
                <span :style="'color: ' + strokeColor">53.505 Aktionsläuferinnen und Läufer</span>
            </li>
            <li v-for="(entry, key) in staticProgress" :key="key">
                + <span :style="'color: ' + getStaticStyle(entry, staticProgress.length - 1 - key).stroke">{{entry.value}} km</span> <i>{{entry.name}}</i>
            </li>
        </ul> -->

        <slot name="footer"></slot>
    </div>
</template>
<!--
        <pre style="text-align: left">
            offset = {{offset}}
            int = {{int}}
            dec = {{dec}}

            strokeWidth = {{strokeWidth}}
            radius = {{radius}}
            transitionDuration = {{transitionDuration}}
            strokeColor = {{strokeColor}}
            value = {{value}}

            circumference = {{circumference}}
            fileStyl = {{fileStyl}}
            circleSize = {{circleSize}}
            centralP = {{centralP}}

            staticProgress = {{staticProgress}}
        </pre>
-->
<script>
    export default {
        props: {
            strokeWidth: {
                type: Number,
                default: 4
            },
            radius: {
                type: Number,
                default: 38
            },
            transitionDuration: {
                type: Number,
                default: 1000
            },
            strokeColor: {
                type: String,
                default: "#aaff00"
            },
            value: {
                validator: function(value) {
                    // should be a number and less or equal than 100
                    return !Number.isNaN(Number(value));
                },
                default: "0.0"
            },
            staticProgress: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                offset: "",
                int: 0,
                dec: "00",
                staticColors: ['#3ac7a6', '#1fabab', '#3281a8', '#9a32a8', '#a88932']
            };
        },
        computed: {
            circumference() {
                return this.radius * Math.PI * 2;
            },
            fileStyl() {
                return {
                    strokeDashoffset: this.offset,
                    "--initialStroke": this.circumference,
                    "--transitionDuration": `${this.transitionDuration}ms`,
                    "stroke-width": this.strokeWidth,
                    stroke: this.strokeColor
                };
            },
            circleSize() {
                return (this.radius + this.strokeWidth) * 2;
            },
            centralP() {
                return this.circleSize / 2;
            },
            staticProgressReversed() {
                return [...this.staticProgress].reverse();
            },
        },
        methods: {
            getStaticStyle(data, index) {
                return {
                    strokeDashoffset: data.offset,
                    "--initialStroke": this.circumference,
                    "--transitionDuration": `${this.transitionDuration}ms`,
                    "stroke-width": this.strokeWidth * (1 + 0.05 * (index + 1)),
                    stroke: this.staticColors[index]//'#ff0000'//this.strokeColor
                    //stroke: this.staticColors[this.staticProgress.length - index - 1]//'#ff0000'//this.strokeColor
                };
            },
            increaseNumber(number, className) {
                if( number == 0 ) {
                    return;
                }
                const innerNum = parseInt(
                    this.findClosestNumber(this.transitionDuration / 10, number)
                );
                let interval = this.transitionDuration / innerNum;

                let counter = 0;
                const handlerName = `${className}Interval`;
                this[handlerName] = setInterval(() => {
                    const bitDiff = number.toString().length - innerNum.toString().length;
                    if( bitDiff == 0 ) {
                        this[className] = counter;
                    } else {
                        this[className] = counter * 10 * bitDiff;
                    }
                    if( counter === innerNum ) {
                        // back to origin precision
                        this[className] = number;
                        window.clearInterval(this[handlerName]);
                    }
                    counter++;
                }, interval);
            },
            findClosestNumber(bound, value) {
                if( value <= bound ) {
                    return value;
                }
                return this.findClosestNumber(bound, value / 10);
            },
            countNumber(v) {
                this.offset = "";

                this.staticProgress.map(data => {
                    data.offset = "";
                    return data;
                });

                this.initTimeoutHandler = setTimeout(() => {
                    if(v >= 100){
                        this.offset = 0;
                    }else{
                        this.offset = (this.circumference * (100 - v)) / 100;
                    }

                    let percentageCounter = 0;
                    this.staticProgress.map(data => {
                        percentageCounter += data.percentage;
                        data.offset = (this.circumference * (100 - percentageCounter * 100)) / 100;
                        return data;
                    });
                }, 100);
                if( this.$slots.default ) return;
                let [int, dec] = v.toString().split(".");

                // fallback for NaN
                [int, dec] = [Number(int), Number(dec)];
                this.increaseNumber(int, "int");
                this.increaseNumber(Number.isNaN(dec) ? 0 : dec, "dec");
            },
            clearHandlers() {
                if( this.initTimeoutHandler ) {
                    clearTimeout(this.initTimeoutHandler);
                }
                if( this.intInterval ) {
                    clearInterval(this.intInterval);
                }
                if( this.decInterval ) {
                    clearInterval(this.decInterval);
                }
            }
        },
        watch: {
            value: {
                handler: function(v) {
                    const n = Number(v);
                    if( Number.isNaN(n) || n == 0 ) {
                        return;
                    }
                    this.clearHandlers();
                    this.countNumber(v);
                },
                immediate: true
            }
        },
        beforeDestroy() {
            this.clearHandlers();
        }
    };
</script>
<style lang="scss">
    @import "~easy-circular-progress/src/index";

    .static-progress-list {
        margin: 0;
        padding: 0;
        list-style: none;
        font-weight: 500;
    }
    .embedded-progress .percent__int {
        font-size:12px!important;
    }
</style>
